import React, { Component } from "react";
import EmpresaContext from "../../context";
// import { Empresa } from "smart-imob-types";
import sectiondata from "../../data/sections.json";
import parse from "html-react-parser";
import GetCorretores from "../../client_api";
import { HBT } from "../../builder-context";
// type TeamState = {
//   usuarios: Object | null;
// };

class Team extends Component {
  constructor(props) {
    super();
    this.state = {
      usuarios: []
    };
  }
  async componentDidMount() {
    const corretores = await GetCorretores(this.context.url, "agenciador_info");
    let usuarios = corretores
      .filter(usuario => usuario.foto)
      .filter(
        usuario => usuario.ocultar === false || usuario.ocultar === undefined
      )
      .filter(
        usuario => usuario.aparecer_site || usuario.aparecer_site === undefined
      );
    console.log("usuarios:", usuarios);
    this.setState({
      usuarios: usuarios
    });
  }
  render() {
    return (
      <div className="team-area bg-gray mg-top-70 pd-top-90 pd-bottom-70">
        <div className="container">
          <div className="section-title text-center">
            <h2 className="title" {...HBT("bb_title_equipe")}>
              {this.context["bb_title_equipe"] || "Somos uma equipe dinâmica"}
            </h2>
          </div>
          <div className="row">
            {this.state.usuarios.map((membro, i) => (
              <div key={i} className="col-lg-4 col-sm-6">
                <div className="single-team">
                  <div className="thumb">
                    <img src={membro.foto} alt={`team_${i}`} />
                  </div>
                  <div className="team-details">
                    <h4>{membro.nome}</h4>
                    <span>{membro.cargo}</span>
                    <br />
                    <span>{membro.email}</span>
                    <br />
                    <span>{membro.telefone}</span>
                    <br />
                    {/* <ul>
                    { membro.social.map( ( social, i )=>
                        <li key={ i }><a href={ social.url }><i className={ social.icon } /></a></li>
                     ) }
                  </ul> */}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

Team.contextType = EmpresaContext;
export default Team;
